/* Draft theme coupon claim → verified discount → existing cart checkout. */
(function () {
  'use strict';
  const root = document.getElementById('bh-coupon-checkout');
  if (!root || root.dataset.initialized || !window.BHCouponCart) return;
  root.dataset.initialized = 'true';
  const config = root.dataset;
  const copy = JSON.parse(root.querySelector('[data-bh-coupon-copy]').textContent);
  const core = window.BHCouponCart.create({ fetch: window.fetch.bind(window), root: config.root.endsWith('/') ? config.root : config.root + '/', code: config.code });
  const dialog = root.querySelector('dialog');
  const claimForm = root.querySelector('[data-bh-coupon-claim]');
  const status = root.querySelector('[data-bh-coupon-status]');
  const actions = root.querySelector('[data-bh-coupon-actions]');
  const retry = root.querySelector('[data-bh-coupon-retry]');
  const continueButton = root.querySelector('[data-bh-coupon-continue]');
  const title = root.querySelector('h2');
  const receiptKey = 'bh-coupon-claim-v1';
  let busy = false, redirectTimer = null, returnFocus = null, suppressAutoRedirect = false, claimAttempt = 0;
  let popupClaimPending = false, duplicatePopupPending = false;
  const popupQA = new URLSearchParams(location.search).get('view') === 'coupon-qa';
  let claimReceipt = false;
  try { claimReceipt = sessionStorage.getItem(receiptKey) === config.code; } catch (_) {}

  function record(stage, details) {
    root.dataset.state = stage;
    root.dispatchEvent(new CustomEvent('bh:coupon-status', { bubbles: true, detail: { stage, ...details } }));
  }
  function money(cart) { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: cart.currency }).format(cart.total_price / 100); }
  function rememberClaim(source) {
    claimReceipt = true;
    try { sessionStorage.setItem(receiptKey, config.code); } catch (_) {}
    updateOffers(); record('claimed', { source });
  }
  function open() {
    if (!dialog.open) { returnFocus = document.activeElement; dialog.showModal(); }
  }
  function cartDestination() {
    const url = new URL(config.cartUrl, location.origin);
    const theme = window.Shopify?.theme;
    if (theme?.id && theme.role && String(theme.role).toLowerCase() !== 'main') url.searchParams.set('preview_theme_id', theme.id);
    return url.href;
  }
  root.querySelector('[data-bh-coupon-return]').href = cartDestination();
  function close() {
    clearTimeout(redirectTimer); suppressAutoRedirect = true; claimAttempt += 1;
    dialog.close(); returnFocus?.focus?.();
    // A shopper can stop the automatic handoff. Show the server-rendered bag
    // with its verified new total, rather than leave an old drawer total visible.
    if (root.dataset.state === 'applied') location.assign(cartDestination());
  }
  function updateOffers() {
    // Cart drawers can be replaced by section rendering. Restore the entry point
    // after a replacement rather than relying on the initial server markup.
    document.querySelectorAll('.cart__ctas').forEach(ctas => {
      const checkoutButton = ctas.querySelector('[name="checkout"]');
      if (!checkoutButton || checkoutButton.disabled || ctas.previousElementSibling?.matches('[data-bh-coupon-open]')) return;
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'bh-coupon-offer'; button.dataset.bhCouponOpen = '';
      ctas.before(button);
    });
    document.querySelectorAll('[data-bh-coupon-open]').forEach(button => {
      const text = claimReceipt ? copy.apply_offer : copy.get_offer;
      if (button.textContent !== text) button.textContent = text;
    });
    checkPopup();
  }
  function popupForm() { return document.querySelector('[data-testid="klaviyo-form-' + config.form + '"]'); }
  function popupSucceeded(form) {
    return form && /Your\s+code\s+is\s+HUSH10\b/i.test(form.textContent.replace(/\s+/g, ' '));
  }
  function checkPopup() {
    const form = popupForm();
    const popupControl = form?.querySelector('button, input');
    if (popupControl?.getClientRects().length && !dialog.open) {
      document.querySelectorAll('dialog[open][aria-labelledby="cart-drawer-heading"]').forEach(drawer => {
        drawer.querySelector('.theme-drawer__close-button')?.click();
      });
    }
    if (duplicatePopupPending && form) {
      const closeButton = form.closest('[role="dialog"]')?.querySelector('button[aria-label="Close dialog"]');
      if (closeButton) { duplicatePopupPending = false; closeButton.click(); }
    }
    // Klaviyo's submit event precedes its successful response. Wait for the
    // configured code-success step as well, so navigation cannot abort capture.
    if (popupClaimPending && !busy && popupSucceeded(form)) {
      popupClaimPending = false;
      rememberClaim('Klaviyo popup success'); handoff(true);
    }
  }
  function checkout() {
    clearTimeout(redirectTimer);
    record('checkout_handoff');
    // Shopify's standard cart POST checkout action uses the current browser cart.
    const form = root.querySelector('[data-bh-coupon-checkout-form]');
    HTMLFormElement.prototype.submit.call(form);
  }
  // Native form.submit() omits the submitter, so keep checkout in a hidden field.
  const checkoutField = document.createElement('input');
  checkoutField.type = 'hidden'; checkoutField.name = 'checkout'; checkoutField.value = 'Checkout';
  root.querySelector('[data-bh-coupon-checkout-form]').append(checkoutField);

  function errorText(code) {
    return {
      EMPTY_CART: copy.empty_cart,
      EXISTING_OFFER: copy.existing_offer,
      DISCOUNT_UNAVAILABLE: copy.discount_unavailable,
      CART_CHANGED: copy.cart_changed,
      RESTORE_FAILED: copy.restore_failed,
      NETWORK: copy.network,
      VERIFY_FAILED: copy.verify_failed
    }[code] || copy.unknown_error;
  }
  async function handoff(autoCheckout = true) {
    if (busy) return;
    busy = true; suppressAutoRedirect = !autoCheckout;
    clearTimeout(redirectTimer); open();
    claimForm.hidden = true; actions.hidden = false;
    retry.hidden = true; continueButton.disabled = true;
    title.textContent = copy.applying_title; status.textContent = copy.applying_body;
    record('applying');
    try {
      const result = await core.apply();
      root.dataset.cartBefore = JSON.stringify({ fingerprint: window.BHCouponCart.fingerprint(result.before), total: result.before.total_price });
      root.dataset.cartAfter = JSON.stringify({ fingerprint: window.BHCouponCart.fingerprint(result.cart), total: result.cart.total_price, discount: config.code, currency: result.cart.currency });
      title.textContent = copy.applied_title;
      status.textContent = copy.applied_body.replace('__TOTAL__', money(result.cart)) + (autoCheckout ? copy.taking_checkout : copy.ready_later);
      continueButton.textContent = copy.checkout; continueButton.disabled = false;
      record('applied', { itemCount: result.cart.item_count, total: result.cart.total_price, currency: result.cart.currency });
      if (autoCheckout && !suppressAutoRedirect && dialog.open) redirectTimer = setTimeout(() => { if (dialog.open && !suppressAutoRedirect) checkout(); }, 1100);
    } catch (error) {
      root.removeAttribute('data-cart-after');
      title.textContent = error.code === 'EMPTY_CART' ? copy.code_title : copy.review_title;
      status.textContent = errorText(error.code);
      retry.hidden = error.code === 'EMPTY_CART';
      continueButton.textContent = copy.current_total;
      continueButton.disabled = ['EMPTY_CART', 'RESTORE_FAILED', 'CART_CHANGED', 'VERIFY_FAILED'].includes(error.code);
      record('failed', { reason: error.code || 'UNKNOWN' });
    } finally { busy = false; }
  }
  async function subscribe(email, source) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 10000);
    try {
      const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(config.company), {
        method: 'POST', signal: controller.signal,
        headers: { 'Content-Type': 'application/vnd.api+json', revision: config.revision },
        body: JSON.stringify({ data: { type: 'subscription', attributes: {
          custom_source: source,
          profile: { data: { type: 'profile', attributes: { email,
            subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
          } } }
        }, relationships: { list: { data: { type: 'list', id: config.list } } } } })
      });
      if (!response.ok) throw new Error('SUBSCRIBE_FAILED');
      rememberClaim(source);
      if (window.klaviyo?.identify) Promise.resolve(window.klaviyo.identify({ email })).catch(() => {});
    } finally { clearTimeout(timer); }
  }
  function startClaim() {
    if (busy) return;
    suppressAutoRedirect = false;
    if (claimReceipt) return handoff(true);
    title.textContent = copy.claim_title;
    status.textContent = ''; claimForm.hidden = false; actions.hidden = true;
    open(); claimForm.querySelector('input').focus(); record('claim_open');
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-bh-coupon-open]');
    if (!trigger) return;
    event.preventDefault(); startClaim();
  });
  root.querySelector('[data-bh-coupon-close]').addEventListener('click', close);
  dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
  dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close(); } });
  retry.addEventListener('click', () => handoff(true));
  root.querySelector('[data-bh-coupon-checkout-form]').addEventListener('submit', event => { event.preventDefault(); if (!continueButton.disabled) checkout(); });
  claimForm.addEventListener('submit', async event => {
    event.preventDefault(); if (busy || !claimForm.reportValidity()) return;
    busy = true;
    const attempt = ++claimAttempt;
    const button = claimForm.querySelector('button'); button.disabled = true;
    status.textContent = copy.claiming; record('claiming');
    try {
      await subscribe(claimForm.elements.email.value.trim(), 'Coupon checkout: cart');
      busy = false;
      if (attempt === claimAttempt && dialog.open) await handoff(true);
    } catch (_) {
      status.textContent = copy.claim_failed;
      record('claim_failed');
    } finally { busy = false; button.disabled = false; }
  });
  // Keep the shared popup configuration untouched; only this draft adds handoff.
  window.addEventListener('klaviyoForms', event => {
    if (event.detail?.formId !== config.form) return;
    if (event.detail.type === 'close') { popupClaimPending = false; return; }
    if (event.detail.type === 'open' && claimReceipt && !popupQA) {
      duplicatePopupPending = true; checkPopup(); return;
    }
    if (event.detail.type === 'submit' && !busy) {
      popupClaimPending = true; record('popup_submitting'); checkPopup();
    }
  });
  document.addEventListener('click', event => {
    const form = popupForm();
    const button = event.target.closest('button, a');
    if (!form || !button || !form.contains(button) || !/^Start shopping$/i.test(button.textContent.trim())) return;
    if (!popupSucceeded(form)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    popupClaimPending = false;
    rememberClaim('Klaviyo popup success'); handoff(true);
  }, true);
  window.addEventListener('bh:cart-saved', () => {
    rememberClaim('Save my cart');
    document.querySelectorAll('.bh-cart-save__msg').forEach(message => {
      if (message.querySelector('[data-bh-coupon-open]')) return;
      const button = document.createElement('button'); button.type = 'button'; button.dataset.bhCouponOpen = '';
      button.textContent = copy.apply_offer; message.append(button);
    });
  });
  // Newsletter submission uses the same public subscription API as Save my cart:
  // no full-page reload, no lost landing URL, and no second email entry.
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.email-signup__form')) return;
    event.preventDefault();
    if (form.dataset.bhSubmitting || !form.reportValidity()) return;
    form.dataset.bhSubmitting = 'true';
    const button = form.querySelector('button'); button.disabled = true;
    let result = form.parentElement.querySelector('.bh-newsletter-result');
    if (!result) { result = document.createElement('div'); result.className = 'bh-newsletter-result'; result.setAttribute('role', 'status'); result.setAttribute('aria-live', 'polite'); form.after(result); }
    result.textContent = copy.submitting;
    try {
      await subscribe(form.querySelector('[name="contact[email]"]').value.trim(), 'Coupon checkout: footer newsletter');
      form.hidden = true;
      result.textContent = copy.footer_success;
      const cart = await core.getCart();
      if (cart.item_count) await handoff(false);
      else result.textContent += copy.add_picks;
      const checkoutButton = document.createElement('button'); checkoutButton.type = 'button'; checkoutButton.dataset.bhCouponOpen = '';
      checkoutButton.textContent = copy.apply_offer; result.append(checkoutButton);
    } catch (_) { result.textContent = claimReceipt ? copy.footer_apply : copy.unknown_error; }
    finally { delete form.dataset.bhSubmitting; button.disabled = false; }
  }, true);
  new MutationObserver(updateOffers).observe(document.body, { childList: true, subtree: true });
  updateOffers(); record('ready');
})();
